<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
                 style="padding-top: 0; margin-top: 0" size="medium">
          <el-form-item label="状态：" >
            <el-select v-model="searchForm.STATUS" filterable placeholder="请选择状态" clearable
                       style="width: 200px;">
              <el-option v-for="item in 状态列表" :key="item.ID" :label="item.LABEL" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button @click="queryData()" size="medium">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top:10px">
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="BRAND" label="品牌"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="SPQ_ID" label="状态">
            <template slot-scope="scope">
              {{ scope.row.SPQ_ID === 0 ? '未上传' : '已上传' }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="查看资质(scope.row)"  >查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      状态列表: [{ ID: '0', LABEL: '未上传' }, { ID: '1', LABEL: '已上传' }],
      searchForm: {},
      // 列表数据
      tableData: [],
      // 数据总条数
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      // 当前页
      currentPage: 1,
    };
  },
  created() {
    this.queryData();
  },
  computed: {

  },
  methods: {
    查看资质(row) {
      this.$router.push({ name: 'viewQualificatDetail' });
      sessionStorage.setItem('产品名称', row.PRODUCT_NAME);
      sessionStorage.setItem('产品编码', row.PRODUCT_CODE);
      sessionStorage.setItem('送货日期', row.SEND_DAY);
      sessionStorage.setItem('资质ID', row.SPQ_ID);
    },
    // 翻页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // 拉取表格数据
    queryData() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 40,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: Number(sessionStorage.getItem('SUPPLIER_ID')),
        SEND_DAY: sessionStorage.getItem('QUALIFICATION_SEND'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.STATUS) {
        params.STATUS = Number(this.searchForm.STATUS);
      }
      http.post(params).then((result) => {
        if (result[0].LIST.length !== 0) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.totalCount = 0;
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/foodSecurity/downloadQualificatDetail.vue